/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Proc_ScopeInputs */

const en_proc_scope = /** @type {(inputs: Proc_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SCOPE`)
};

const ar_proc_scope = /** @type {(inputs: Proc_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النطاق`)
};

const bn_proc_scope = /** @type {(inputs: Proc_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কোপ`)
};

const de_proc_scope = /** @type {(inputs: Proc_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SCOPE`)
};

const es_proc_scope = /** @type {(inputs: Proc_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SCOPE`)
};

const fr_proc_scope = /** @type {(inputs: Proc_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SCOPE`)
};

const pt_proc_scope = /** @type {(inputs: Proc_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SCOPE`)
};

const zh_proc_scope = /** @type {(inputs: Proc_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SCOPE`)
};

const tr_proc_scope = /** @type {(inputs: Proc_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SCOPE`)
};

const ru_proc_scope = /** @type {(inputs: Proc_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SCOPE`)
};

const pl_proc_scope = /** @type {(inputs: Proc_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SCOPE`)
};

/**
* | output |
* | --- |
* | "SCOPE" |
*
* @param {Proc_ScopeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const proc_scope = /** @type {((inputs?: Proc_ScopeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Proc_ScopeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_proc_scope(inputs)
	if (locale === "bn") return bn_proc_scope(inputs)
	if (locale === "de") return de_proc_scope(inputs)
	if (locale === "es") return es_proc_scope(inputs)
	if (locale === "fr") return fr_proc_scope(inputs)
	if (locale === "pt") return pt_proc_scope(inputs)
	if (locale === "zh") return zh_proc_scope(inputs)
	if (locale === "tr") return tr_proc_scope(inputs)
	if (locale === "ru") return ru_proc_scope(inputs)
	if (locale === "pl") return pl_proc_scope(inputs)
	return en_proc_scope(inputs)
});